import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'

export const trackHostRescheduleNowClick = ({
  track,
  isOneOnOneEventType,
  eventTypeId,
}) => {
  track({
    name: TRACKING_EVENT_NAMES.FLOW_STEP_CLICKED,
    properties: {
      flow_name: 'host_reschedule_request',
      flow_location: isOneOnOneEventType ? 'event_details' : 'invitee_details',
      flow_version: 'v1',
      flow_step: null,
      completion_method: 'interaction',
      event_type_id: eventTypeId,
    },
  })
}
